import React, { useEffect, useState } from "react";
import LoadingSpinner from "../../components/LoadingSpinner";
import axios from "axios";
import { ApiConnectionString } from "../../constants/ApiConntection";
import { useAuthContext } from "../../hooks/useAuthContext";
//styled
export default function BookingCancellationRequested({ notification }) {
  const [booking, setBooking] = useState(null);

  
  const [isLoading, setIsLoading] = useState(true);
  const [complete, setComplete] = useState(false);
  const [accepted,setAccepted] = useState(false)
  const [refused,setRefused] = useState(false)
  const {user} = useAuthContext()

  

  const accept = async () => {
    try {
      setIsLoading(true); // Start loading
      
      const cancelBookingResponse = await axios.delete(`${ApiConnectionString}/api/Booking/${booking.id}`, {
        headers: { Authorization: `Bearer ${user.token}` },
      });

      if (cancelBookingResponse.status == 200) {
        setAccepted(true)
        setComplete(true); // Set completion state
      }
    } catch (error) {
      console.error("Error canceling booking:", error); // Handle any errors
      // Optionally, set an error state or display an error message to the user
    } finally {
      setIsLoading(false); // Stop loading regardless of success or failure
    }
  }
  const refuse = async () => {
    try {
      setIsLoading(true); // Start loading
      
      const updatebooking = {
        id: booking.id,
      };
      const updateBookingResponse = await axios.put(
        `${ApiConnectionString}/api/booking`,
        updatebooking,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
  
      if (updateBookingResponse.status == 200) {
        setComplete(true)
        setRefused(true);
      } else {
        //handle
      }
    } catch (error) {
      console.error("Error canceling booking:", error); // Handle any errors
      // Optionally, set an error state or display an error message to the user
    } finally {
      setIsLoading(false); // Stop loading regardless of success or failure
    }
  }

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const bookingResponse = await axios.get(
        `${ApiConnectionString}/api/booking/${notification.bookingId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (bookingResponse.status === 200) {
        setBooking(bookingResponse.data);
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 404) {
          // Handle 404 status gracefully (e.g., setBooking to null or empty object)
          setBooking(null);
        
        } else {
          console.error("Error fetching booking data:", error); // Log other errors
          setBooking(null);
        }
      } else {
        console.error("Error fetching booking data:", error); // Handle network errors
        setBooking(null);
      }
    } finally {
      setIsLoading(false); // Ensure loading stops whether the request is successful or fails
    }
  };
  

  useEffect(() => {
fetchData()
  },[notification.id,user])

  if (isLoading) {
    return (
      <div className="container">
        <LoadingSpinner />
      </div>
    );
  } else {
    if(booking){
      return (
        <div className="container bg-white">
          <div className="blueBanner">
<p className="fw-bold p-2"> {notification.title}</p>
          </div>
        
          <p>{notification.content}
          </p>
      {booking.cancelPending  ?  <div className="cancel-request-box">
          {!complete  &&  <div> <p>You can confirm or refuse their request.</p>      <div className="d-flex justify-content-between">
           
          <button onClick={accept} className="saveChanges-button">
                Confirm
              </button>
              <button  onClick={refuse} className="delete-button">
                Refuse
              </button>
          
            </div> </div>}
            {complete && refused && <p>Booking cancelation request refused</p>}
            {complete && accepted && <p className="text-success">
  Booking canceled. You have confirmed their request to cancel this booking.
</p>
}
          </div> : <p>This booking no longer needs delt with</p>}
  
     
          {/* <p>
            <strong>Timestamp:</strong> {notification.timestamp}
          </p> */}
        </div>
      );
    }
    }{
      return (
        <div className="container bg-white">
        <div className="blueBanner">
<p className="fw-bold p-2"> {notification.title}</p>
          </div>
            <strong>Booking not found</strong> 
        
        </div>
      );
    }
 
}
